import React from 'react';
import '../../App.css';
import Form from 'react-bootstrap/Form';


export default function CadastroSucesso() {
    return <>
        <body className= 'cadastro-sucesso'>
            <h1 className='title'>Seu cadastro foi um sucesso!</h1>
        </body>
    </>;

}